

// import { initializeApp } from 'firebase/app';
// import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
// import {
//   getFirestore,
//   doc,
//   setDoc,
//   collection,
//   addDoc,
//   getDocs,
//   deleteDoc,
//   onSnapshot
// } from 'firebase/firestore';
// import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
// import { getAnalytics } from 'firebase/analytics';

// const firebaseConfig = {
//     apiKey: "AIzaSyDeWTbVnNbsH8radg_aeUWLt9vbzKlLKJ8",
//     authDomain: "karanks--1436.firebaseapp.com",
//     projectId: "karanks--1436",
//     storageBucket: "karanks--1436.firebasestorage.app",
//     messagingSenderId: "277555661568",
//     appId: "1:277555661568:web:7d6dfc705014ebd67141e5",
//     measurementId: "G-QPEH4WKFM0"
//   }

// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const db = getFirestore(app);
// const analytics = getAnalytics(app);
// const storage = getStorage(app);

// export {
//   auth,
//   db,
//   storage,
//   createUserWithEmailAndPassword,
//   signInWithEmailAndPassword,
//   setDoc,
//   doc,
//   collection,
//   addDoc,
//   getDocs,
//   deleteDoc,
//   onSnapshot,
//   ref,
//   uploadBytes,
//   getDownloadURL,
// };






import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {
  getFirestore,
  doc,
  setDoc,
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  onSnapshot
} from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyDeWTbVnNbsH8radg_aeUWLt9vbzKlLKJ8",
    authDomain: "karanks--1436.firebaseapp.com",
    projectId: "karanks--1436",
    storageBucket: "karanks--1436.firebasestorage.app",
    messagingSenderId: "277555661568",
    appId: "1:277555661568:web:7d6dfc705014ebd67141e5",
    measurementId: "G-QPEH4WKFM0"
  }

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);
const messaging = getMessaging(app);




export {
  app,
  auth,
  db,
  storage,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  setDoc,
  doc,
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  onSnapshot,
  ref,
  uploadBytes,
  getDownloadURL,
  messaging,
   getToken, 
   onMessage,
};
